import styled from 'styled-components'

interface StyledIconProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    position?: 'absolute' | 'relative' | 'static' | 'fixed' | 'sticky'
}

const sizeMap = {
    xs: '10px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '45px',
}

export const Icon = styled.img<StyledIconProps>`
    height: ${({size}) => (size ? sizeMap[size] : sizeMap.sm)};
    width: ${({size}) => (size ? sizeMap[size] : sizeMap.sm)};
    position: ${({position}) => (position ? position : 'static')};
    vertical-align: top;
`
